import React, { useState, useEffect, useRef } from 'react';
import emailjs from '@emailjs/browser';
import './LibroReclamaciones.css';

const LibroReclamaciones = () => {
  const formRef = useRef();
  const [fecha, setFecha] = useState('--/--/----');
  const [cargando, setCargando] = useState(false);
  const [alertaExito, setAlertaExito] = useState(false);
  const [alertaError, setAlertaError] = useState(false);

  // Estado para controlar la opción seleccionada (DNI por defecto)
  const [tipoDoc, setTipoDoc] = useState('DNI');

  const SUPABASE_URL = "https://yehzsmvmeaxteqjdqixe.supabase.co/rest/v1"; 
  const SUPABASE_ANON_KEY = "sb_publishable_uciWrgaTw41dTL2mIT8XHw_uML1TT7w";

  useEffect(() => {
    emailjs.init('a43-B8VoB8yaaYSF3');
    const hoy = new Date();
    setFecha(hoy.toLocaleDateString('es-PE', { day: '2-digit', month: '2-digit', year: 'numeric' }));
  }, []);

  // Reglas dinamicas segun las 3 opciones (DNI, CE, PAS)
  const obtenerConfigDoc = () => {
    switch (tipoDoc) {
      case 'DNI':
        return { placeholder: 'Ingrese sus 8 dígitos', maxLength: 8, pattern: '[0-9]{8}' };
      case 'CE':
        return { placeholder: 'Ingrese 9 dígitos', maxLength: 9, pattern: '[0-9]{9}' };
      case 'PAS':
        return { placeholder: 'Ingrese 9 dígitos', maxLength: 9, pattern: '[A-Za-z0-9]{9}' };
      default:
        return { placeholder: 'Ingrese su documento', maxLength: 12, pattern: '.*' };
    }
  };

  const configDoc = obtenerConfigDoc();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setCargando(true);
    setAlertaExito(false);
    setAlertaError(false);

    const formData = new FormData(formRef.current);

    const datosReclamo = {
      tipo_consumidor: formData.get('tipo-consumidor'),
      nombre1: formData.get('nombre1'),
      apellido1: formData.get('apellido1'),
      tipo_doc: formData.get('tipo-doc'),
      nro_doc: formData.get('nro-doc'),
      email: formData.get('email'),
      direccion: formData.get('direccion'),
      celular: formData.get('celular'),
      producto_tipo: formData.get('producto-tipo'),
      producto_programa: formData.get('producto-programa'),
      producto_monto: formData.get('producto-monto'),
      producto_descripcion: formData.get('producto-descripcion'),
      tipo_reclamo: formData.get('tipo-reclamo'),
      detalle: formData.get('detalle'),
      pedido_reclamo: formData.get('pedido-reclamo')
    };

    try {
      const respuesta = await fetch(`${SUPABASE_URL}/libro_reclamaciones`, {
        method: 'POST',
        headers: {
          'apikey': SUPABASE_ANON_KEY,
          'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
          'Content-Type': 'application/json',
          'Prefer': 'return=minimal'
        },
        body: JSON.stringify(datosReclamo)
      });

      if (!respuesta.ok) throw new Error('Error al guardar en Supabase');

      const templateParams = {
        nombre1: formData.get('nombre1'),
        apellido1: formData.get('apellido1'),
        nro_doc: formData.get('nro-doc'),
        email: formData.get('email'),
        celular: formData.get('celular'),
        direccion: formData.get('direccion'),
        producto_tipo: formData.get('producto-tipo'),
        producto_programa: formData.get('producto-programa'),
        producto_monto: formData.get('producto-monto'),
        tipo_reclamo: formData.get('tipo-reclamo'),
        detalle: formData.get('detalle'),
        pedido_reclamo: formData.get('pedido-reclamo')
      };

      await emailjs.send('service_qbxpuw9', 'template_yv2awnk', templateParams);

      setAlertaExito(true);
      formRef.current.reset();
      setTipoDoc('DNI');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (error) {
      console.error('Error:', error);
      setAlertaError(true);
    } finally {
      setCargando(false);
    }
  };

  return (
    <main className="reclamos-wrapper">
      <div className="libro-container">
        
        <header className="libro-header">
  <div className="header-left">
    <img 
      src="/uploads/Logop.png" 
      alt="Escuela de Gerencia y Gestión" 
      className="logo-libro-img" 
    />
    <h1>LIBRO DE RECLAMACIONES</h1>
    <p className="leyenda">Hoja de Reclamación conforme al Código de Protección y Defensa del Consumidor</p>
  </div>
          
          <div className="header-right">
            <div className="fecha-box">
              <span className="fecha-label">FECHA DE REGISTRO</span>
              <span className="fecha-valor">{fecha}</span>
            </div>
          </div>
        </header>

        {alertaExito && (
          <div className="alerta-exito">
            ¡Su reclamo ha sido registrado con éxito en nuestro sistema!
          </div>
        )}
        {alertaError && (
          <div className="alerta-error">
            Hubo un problema al enviar su reclamo. Por favor, inténtelo nuevamente.
          </div>
        )}

        <form ref={formRef} onSubmit={handleSubmit} className="form-libro">
          <div className="grid-layout-columnas">
            
            <div className="columna-bloque">
              <div className="seccion-titulo-nueva">
                <h3>Información del Consumidor</h3>
              </div>

              <div className="campos-lista-nuevo">
                <div className="campo-grupo-vertical">
                  <label htmlFor="tipo-consumidor">Tipo de Consumidor</label>
                  <div className="custom-select">
                    <select id="tipo-consumidor" name="tipo-consumidor" defaultValue="Persona Natural">
                      <option value="Persona Natural">Persona Natural</option>
                      <option value="Persona Jurídica">Persona Jurídica</option>
                    </select>
                  </div>
                </div>

                <div className="campo-grupo-vertical">
                  <label htmlFor="nombre1">Nombres *</label>
                  <input type="text" id="nombre1" name="nombre1" placeholder="Joe" required />
                </div>

                <div className="campo-grupo-vertical">
                  <label htmlFor="apellido1">Apellidos *</label>
                  <input type="text" id="apellido1" name="apellido1" placeholder="Doe" required />
                </div>

                <div className="sub-grid-inputs">
                  <div className="campo-grupo-vertical">
                    <label htmlFor="tipo-doc">Tipo de Documento</label>
                    <div className="custom-select">
                      <select 
                        id="tipo-doc" 
                        name="tipo-doc" 
                        value={tipoDoc} 
                        onChange={(e) => setTipoDoc(e.target.value)}
                        required
                      >
                        <option value="DNI">DNI</option>
                        <option value="CE">CE</option>
                        <option value="PAS">PAS</option>
                      </select>
                    </div>
                  </div>
                  <div className="campo-grupo-vertical">
                    <label htmlFor="nro-doc">Número de Documento *</label>
                    <input 
                      type="text" 
                      id="nro-doc" 
                      name="nro-doc" 
                      placeholder={configDoc.placeholder} 
                      maxLength={configDoc.maxLength}
                      pattern={configDoc.pattern}
                      title={`Ingrese el formato válido para ${tipoDoc}`}
                      required 
                    />
                  </div>
                </div>

                <div className="campo-grupo-vertical">
                  <label htmlFor="email">Correo *</label>
                  <input type="email" id="email" name="email" placeholder="tucorreo@gmail.com" required />
                </div>

                <div className="campo-grupo-vertical">
                  <label htmlFor="direccion">Dirección *</label>
                  <input type="text" id="direccion" name="direccion" placeholder="Av. Arenales , Lince" required />
                </div>

                <div className="campo-grupo-vertical">
                  <label htmlFor="celular">Celular *</label>
                  <input type="text" id="celular" name="celular" placeholder="999999999" maxLength="9" pattern="[0-9]{9}" required />
                </div>
              </div>
            </div>

            <div className="columna-bloque">
              <div className="seccion-titulo-nueva">
                <h3>Identificación del producto contratado</h3>
              </div>

              <div className="campos-lista-nuevo">
                <div className="sub-grid-inputs">
                  <div className="campo-grupo-vertical">
                    <label htmlFor="producto-tipo">Tipo</label>
                    <div className="custom-select">
                      <select id="producto-tipo" name="producto-tipo" defaultValue="Curso">
                        <option value="Curso">Curso</option>
                        <option value="Diploma">Diploma</option>
                      </select>
                    </div>
                  </div>
                  <div className="campo-grupo-vertical">
                    <label htmlFor="producto-programa">Título de Programa:</label>
                    <input type="text" id="producto-programa" name="producto-programa" placeholder="Curso XXX" />
                  </div>
                </div>

                <div className="campo-grupo-vertical">
                  <label htmlFor="producto-monto">Monto Reclamado:</label>
                  <input type="text" id="producto-monto" name="producto-monto" placeholder="S/. 100.00" />
                </div>

                <div className="campo-grupo-vertical">
                  <label htmlFor="producto-descripcion">Descripción:</label>
                  <textarea id="producto-descripcion" name="producto-descripcion" rows="2" placeholder="Descripción"></textarea>
                </div>

                <div className="seccion-titulo-nueva" style={{ marginTop: '25px' }}>
                  <h3>Detalle del reclamo</h3>
                </div>

                <div className="campo-grupo-vertical">
                  <label htmlFor="tipo-reclamo">Tipo del Reclamo</label>
                  <div className="custom-select">
                    <select id="tipo-reclamo" name="tipo-reclamo" defaultValue="Reclamo">
                      <option value="Reclamo">Reclamo</option>
                      <option value="Queja">Queja</option>
                    </select>
                  </div>
                </div>

                <div className="campo-grupo-vertical">
                  <label htmlFor="detalle">Detalle del Reclamo:</label>
                  <textarea id="detalle" name="detalle" rows="2" placeholder="Detalle del Reclamo" required></textarea>
                </div>

                <div className="campo-grupo-vertical">
                  <label htmlFor="pedido-reclamo">Pedido del Reclamo:</label>
                  <textarea id="pedido-reclamo" name="pedido-reclamo" rows="2" placeholder="Descripción del Reclamo"></textarea>
                </div>

                <div className="checkbox-legal">
                  <input type="checkbox" id="terminos" required />
                  <label htmlFor="terminos">
                    Declaro ser el usuario del servicio o producto y acepto el contenido del presente formulario manifestando bajo Declaración Jurada la veracidad de los hechos descritos, y acepto la <a href="#" target="_blank" rel="noreferrer">POLÍTICA DE PROTECCIÓN DE DATOS PERSONALES</a>
                  </label>
                </div>
              </div>
            </div>

          </div>

          <div className="form-footer-nuevo">
            <button type="submit" className="btn-enviar" disabled={cargando}>
              {cargando ? "Enviando..." : "Enviar"}
            </button>
          </div>
        </form>
      </div>
    </main>
  );
};

export default LibroReclamaciones;